import React, { useEffect, useState } from 'react';
import { brand, navLinks } from '../data/site';
export function SiteNav() {
  const [lifted, setLifted] = useState(false);
  useEffect(() => {
    const onScroll = () => setLifted(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-3 z-40 transition-all duration-700 ${lifted ? 'border-b border-hair/60 bg-ink/85 backdrop-blur-md' : 'border-b border-transparent bg-gradient-to-b from-black/70 to-transparent'}`} data-id="element-146" data-mp="31n3zsec14jcm">
      <div className="flex items-center justify-between px-6 py-5 md:px-12 lg:px-14" data-id="element-147" data-mp="2rq7yotogmzi3">
        <a href="#ritual" className="font-display text-lg uppercase tracking-[0.18em] text-cream transition-colors hover:text-brass md:text-xl" data-id="element-148" data-mp="2mrenj7wnbkl3">
          Wabash <span className="text-brass" data-id="element-149" data-mp="kygqezvu65uc">&amp;</span> Roast
        </a>

        <nav aria-label="Primary" data-id="element-150" data-mp="8zcgunklz0lh">
          <ul className="hidden items-center gap-9 md:flex" data-id="element-151" data-mp="8yawttlm73rm">
            {navLinks.map(link => <li key={link.label} data-id="element-152" data-mp="e009tesedric">
                <a href={link.href} className="group relative font-mono text-[10.5px] uppercase tracking-[0.25em] text-stone transition-colors hover:text-cream" data-id="element-153" data-mp="3v72ekbf2l1k5">
                  {link.label}
                  <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-brass transition-all duration-500 group-hover:w-full" data-id="element-154" data-mp="rqlv1a5bqdje" />
                </a>
              </li>)}
          </ul>
          <a href="#visit" className="font-mono text-[10px] uppercase tracking-[0.25em] text-brass md:hidden" data-id="element-155" data-mp="hziq1x99xeeu">
            Visit
          </a>
        </nav>
      </div>
      <span className="sr-only" data-id="element-156" data-mp="1aneob6ehredq">{brand.name}</span>
    </header>;
}